import React, { } from 'react';
import { Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, ButtonGroup, IconButton, } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import MainPagination from '../../general/MainPagination';
import _ from 'lodash';

const columnsStaff = [
    { id: 'num', label: '#l', minWidth: 50, align: 'left', },
    { id: 'sel', label: 'Sel', minWidth: 50, align: 'left', },
    { id: 'codSghh', label: 'Código', minWidth: 120, align: 'left', },
    { id: 'trabajador', label: 'Nombre', minWidth: 200, align: 'left', },
];

const columns = [
    { id: 'id_supArea', label: '#', minWidth: 100, align: 'left', },
    { id: 'codSghh', label: 'Código', minWidth: 120, align: 'left', },
    { id: 'trabajador', label: 'Nombre', minWidth: 200, align: 'left', },
    { id: 'delete', label: 'Eliminar', minWidth: 200, align: 'left', },
];

const SuperAreas = (props) => {
    const { totalPagesStaff, pageStaff, setPageStaff, idUsuario, infoArea, dataStaffs, dataSuperArea, setDataSuperArea, dataSuperAreaCopy, setDataSuperAreaCopy, } = props;


    const handleChangeCheck = (value, p_person) => {
        let updDataSuperAreaCopy = _.cloneDeep(dataSuperAreaCopy);
        let updDataSuperArea = _.cloneDeep(dataSuperArea);

        if (value === false) {
            updDataSuperAreaCopy = updDataSuperAreaCopy?.filter((e) => Number(e.id_persona) !== Number(p_person.id_persona));
        } else {
            let newItem = {
                "id_persona": p_person.id_persona,
                "id_area": infoArea?.id_area,
                "estado": 1,
                "usuario_id": idUsuario,
                "id_persona": p_person.id_persona,
                "nombres": p_person.nombres,
                "apePaterno": p_person.apePaterno,
                "apeMaterno": p_person.apeMaterno,
                "trabajador": p_person.nombres,
                "codSghh": p_person.codSghh
            }
            updDataSuperAreaCopy.push(newItem);
            updDataSuperArea.push(newItem);
        }

        setDataSuperArea(updDataSuperArea)
        return setDataSuperAreaCopy(updDataSuperAreaCopy);
    }

    const f_deleteSuperArea = (idx, info) => {
        let updDataSuperArea = _.cloneDeep(dataSuperArea);
        let updDataSuperAreaCopy = _.cloneDeep(dataSuperAreaCopy);
        updDataSuperAreaCopy[idx]['estado'] = 2;

        setDataSuperArea(updDataSuperArea?.filter(e => Number(e.id_persona) !== Number(info.id_persona)))
        setDataSuperAreaCopy(updDataSuperAreaCopy);
    }

    return (
        <>
            <Typography gutterBottom variant="subtitle2" component="div" color={'GrayText'}>
                Lista de trabajadores
            </Typography>
            <div className='page-body-main'>
                <div className='page-body__table' style={{ overflow: 'hidden', height: '23vh' }}>
                    <div className='page-body-table'>
                        <TableContainer className='table-height' style={{ height: '23vh' }}>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        {columnsStaff.map((column) => {
                                            return (
                                                <TableCell
                                                    key={column.id}
                                                    align={column.align}
                                                    style={{ minWidth: column.minWidth }}
                                                >
                                                    {column.label}
                                                </TableCell>
                                            )
                                        })}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {dataStaffs?.map((record, indexRow) => {
                                        return (
                                            <TableRow hover role="checkbox" tabIndex={-1} key={"row" + indexRow}>
                                                {columnsStaff.map((column, indexColumn) => {
                                                    const value = record[column.id];
                                                    return (
                                                        <TableCell key={'col' + indexColumn} align={column.align}>
                                                            {column.id === 'num' ?
                                                                indexRow + 1
                                                                : column.id === 'sel' ?
                                                                    <div className="checkbox-custom"
                                                                        style={{ display: 'flex', justifyContent: 'center' }}
                                                                    >
                                                                        <input type="checkbox"
                                                                            name="check"
                                                                            id={`checkbox-rect` + record.id_persona}
                                                                            checked={dataSuperArea?.find(e => Number(e.id_persona) === Number(record.id_persona)) ? true : false}
                                                                            disabled={dataSuperArea?.find(e => Number(e.id_persona) === Number(record.id_persona)) ? true : false}
                                                                            onChange={(e) => handleChangeCheck(e.target.checked, record)}
                                                                        />
                                                                        <label htmlFor={`checkbox-rect` + record.id_persona}></label>
                                                                    </div> :
                                                                    value
                                                            }
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </div>
            {totalPagesStaff > 1 &&
                <MainPagination
                    size={'small'}
                    totalPages={totalPagesStaff}
                    page={pageStaff}
                    setPage={setPageStaff}
                />
            }
            <Typography gutterBottom variant="subtitle2" component="div" color={'GrayText'}>
                Lista de supervisores
            </Typography>
            <div className='page-body-main'>
                <div className='page-body__table' style={{ overflow: 'hidden', height: '23vh' }}>
                    <div className='page-body-table'>
                        <TableContainer className='table-height' style={{ height: '23vh' }}>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        {columns.map((column) => (
                                            <TableCell
                                                key={column.id}
                                                align={column.align}
                                                style={{ minWidth: column.minWidth }}
                                            >
                                                {column.label}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {dataSuperArea?.map((record, indexRow) => {
                                        return (
                                            <TableRow hover role="checkbox" tabIndex={-1} key={"row" + indexRow}>
                                                {columns.map((column, indexColumn) => {
                                                    const value = record[column.id];
                                                    return (
                                                        <TableCell key={'col' + indexColumn} align={column.align}>
                                                            {column.id === 'delete' ?
                                                                <ButtonGroup
                                                                    disableElevation
                                                                    variant="contained"
                                                                    aria-label="Disabled elevation buttons"
                                                                >
                                                                    <IconButton aria-label="delete" size="small" style={{ border: `solid 1px red` }}
                                                                        onClick={() => { f_deleteSuperArea(indexRow, record); }}
                                                                        title='Eliminar supervisor'
                                                                    >
                                                                        <DeleteIcon color={'error'} fontSize={'12px'} />
                                                                    </IconButton>
                                                                </ButtonGroup> : value}
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SuperAreas;